import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import Modal from "../../../components/Modal/Modal";
import ImageUpload from "../../../components/Image/ImageUploadWithDefaultSize";
import {
  addEventApplication,
  updateEventApplication,
  getEventApplicationByEventId,
  uploadEventApplicationImage,
} from "../../../services/EventApplicationService";
import { DocumentTypeService, EventService } from "../../../services";
import eventApplicationCreateModel from "../../../components/Model/EventApplicationModel";
import ImagePreview from "../../../components/Image/ImagePreview";
import Editor from "react-simple-wysiwyg";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { useParams } from "react-router-dom";
import { injectModels } from "../../../redux/injectModels";
import { ApplicationType } from "../../../constants/Enum";
import {
  EventContractService,
  AuthService,
  SubscriptionService,
} from "../../../services";
import Swal from "sweetalert2";
import {
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";

const AddEventApplication = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [documentList, setDocumentList] = useState([]);
  const [isBronzePlan, setSeletedPlan] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const [previewImageURL, setPreviewImageURL] = useState("");
  const [contractTC, setContractTC] = useState(null);
  const [eventApplicationData, setEventApplicationData] = useState({
    ...eventApplicationCreateModel,
  });
  const [applicationForValue, setApplicationForValue] = useState("");
  const [applicationForHeading, setApplicationForHeading] = useState("Caterer");
  const { eventId, param } = useParams();
  const [maxDate, setMaxDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [minDate, setMinDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedPercentage, setSelectedPercentage] = useState("");
  const [docerror, setDocError] = useState("");
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    setError,
    trigger,
    clearErrors,
    formState: { errors },
  } = useForm();

  const openCoverModal = () => {
    setPreviewImageURL(eventApplicationData?.image);
    openModal();
  };

  const [seletedDocments, setSelectedDocuments] = useState([]);

  const handlePercentageChange = (event) => {
    // const value = event.target.value;

    const value = event.target.value;
    // If the value is not a number or out of range (0-100), set an error message
    if (value === "" || isNaN(value) || value < 50 || value > 100) {
      setError("initialPaymentPer", {
        message: "Please enter a valid number between 50 and 100",
      });
      // event.target.value = "";
    } else {
      // Clear the error if the value is valid
      // We don't need to set an error in this case, so we use `clearErrors` if you want to clear it
      if (value >= 0 && value <= 100) {
        clearErrors("initialPaymentPer");
        setSelectedPercentage(value);
        if (value === "100") {
          setEventApplicationData({
            ...eventApplicationData,
            payOutDate: null,
          });
           setSelectedPercentage(value);
        }
        else{
          if(eventApplicationData.secondPaymentInterval===0)        
          setValue(
          "secondPaymentInterval",
          null
        );
           trigger("secondPaymentInterval");
        }
      }
    }
  };

  const handleBackButton = (e) => {
    e.preventDefault();
    navigate(routes.ACCOUNT_EVENTS);
  };
  const onSubmit = async (data) => {
    if (!data.requiredDocuments) {
      setDocError("Please select require documents");
      return;
    } else {
      setDocError("");
    }
    data.termsCondition = contractTC;

    if (
      (data.initialPaymentPer && data.initialPaymentPer < 50) ||
      data.initialPaymentPer > 100
    ) {
      setError("initialPaymentPer", {
        message: "Please enter a valid number between 50 and 100",
      });
      return;
    } else {
      clearErrors("initialPaymentPer");
    }
    try {
      props.application.setLoading(true);
      if (selectedPercentage === "100") {
        data.payOutDate = null;
        data.secondPaymentInterval=0;
      }
      if (data.amount === "") {
        data.amount = null;
      }
      if (data.auctionsDays === "") {
        data.auctionsDays = null;
      }
      if (Number(data.applicationType) === Number(ApplicationType.Fixed)) {
        data.auctionsDays = null;
      }

      if (data.auctionStartDate === "") {
        data.auctionStartDate = null;
      }
      const eventApplicationData = {
        ...eventApplicationCreateModel,
        ...data,
      };
      eventApplicationData.eventId = eventId;
      eventApplicationData.applicationFor = param;
      const response =
        eventApplicationData.id === null
          ? await addEventApplication(eventApplicationData)
          : await updateEventApplication(eventApplicationData);
      if (response?.isSuccess) {
        getEventApplication();
        props.application.setLoading(false);
        toast.success(response?.message);
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const getEventApplication = async () => {
    try {
      const documentList = await getDocumentData();
      setDocumentList(documentList);
      setSelectedDocuments([]);
       setPreviewImageURL("");
      try {
        var event = await EventService.getEventById(eventId);
        if (event?.data?.startDate) {
          const parsedMinDate = new Date();

          if (!isNaN(parsedMinDate)) {
            const day = String(parsedMinDate.getDate()).padStart(2, "0"); // Ensure two digits
            const month = String(parsedMinDate.getMonth() + 1).padStart(2, "0"); // Ensure two digits
            const year = parsedMinDate.getFullYear();

            const correctedMinDate = `${year}-${month}-${day}`; // Correct ISO format
            setMinDate(correctedMinDate);
          }
          const parsedDate = new Date(event?.data?.startDate);

          if (!isNaN(parsedDate)) {
            const day = String(parsedDate.getDate()).padStart(2, "0"); // Ensure two digits
            const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Ensure two digits
            const year = parsedDate.getFullYear();

            const correctedDate = `${year}-${month}-${day}`; // Correct ISO format
            setMaxDate(correctedDate);
            if (parsedMinDate > parsedDate) {
              setMinDate(correctedDate);
            }
          }
        } else {
          Swal.fire({
            title: "Event Start Date Missing",
            text: "Please add event start date before application setup.",
            icon: "warning",
            buttonsStyling: false,
          });
        }
      } catch (error) {
       const message= handleConsoleError(error);
        toast.error(error?.message|| message);
      }

      setEventApplicationData({ ...eventApplicationData, eventId: eventId });
      const application = await getEventApplicationByEventId(eventId, param);
      if (application.isSuccess && application.data) {
        setPreviewImageURL(application?.data?.[0]?.image);
        const applicationMappedData = {
          ...eventApplicationCreateModel,
          ...application?.data?.[0],
        };

        setSelectedPercentage(applicationMappedData.initialPaymentPer);
        if (applicationMappedData.deadLine) {
          applicationMappedData.deadLine = applicationMappedData?.deadLine?.split(
            "T"
          )[0];
        }

        if (applicationMappedData.payOutDate) {
          applicationMappedData.payOutDate = applicationMappedData?.payOutDate?.split(
            "T"
          )[0];
        }
        if (applicationMappedData.auctionStartDate) {
          applicationMappedData.auctionStartDate = applicationMappedData?.auctionStartDate?.split(
            "T"
          )[0];
        }
        // for Auto generate TERMS AND CONDITIONS
        setContractTC(applicationMappedData?.termsCondition);
        setEventApplicationData(applicationMappedData);
        //filter selected record
        const idsArray = applicationMappedData.requiredDocuments
          ? applicationMappedData?.requiredDocuments
              .split(",")
              .map((id) => id.trim())
          : [];
        const filteredList = documentList.map((item) => {
          item.checked = idsArray?.includes(item.id) ? true : false;
          return item;
        });
        if (filteredList && filteredList.length > 0) {
          setSelectedDocuments(filteredList.filter((x) => x.checked === true));
          setDocumentList(filteredList);
          setDocError("");
        }
        reset(applicationMappedData);
      } else {
        //setSelectedDocuments(documentList);        
        setEventApplicationData(eventApplicationCreateModel);
        reset(eventApplicationCreateModel);
      }
    } catch (error) {
      setEventApplicationData(eventApplicationCreateModel);     
      reset(eventApplicationCreateModel);
       const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const handleImageUpload = async (file) => {
    props.application.setLoading(true);
    const formData = new FormData();
    formData.append("Image", file.get("image"));
    if (eventApplicationData.id !== null) {
      formData.append("Id", eventApplicationData.id);
    }
    formData.append("EventId", eventId);
    formData.append("type", applicationForValue);
    try {
      const response = await uploadEventApplicationImage(formData);
      if (response?.isSuccess) {
        props.application.setLoading(false);
        closeModal();
        setEventApplicationData({
          id: response?.data?.applicationId,
          ...eventApplicationData,
        });
        setPreviewImageURL(response?.data?.completeURL);
        setValue("id", response?.data?.applicationId);
        toast.success(response?.message);
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (err) {
      props.application.setLoading(false);
      const message = handleConsoleError(err);
      toast.error(err?.message || message);
    }
  };
  const handleDescription = (e) => {
    const val = e.target.value;

    setEventApplicationData({ ...eventApplicationData, description: val });
    setValue("description", val);
  };

  //****** Handle Change for terms and condtitons *******
  const handleTermsCondition = (e) => {
    const val = e.target.value;
    setContractTC(val);
    setEventApplicationData({ ...eventApplicationData, termsCondition: val });
    setValue("termsCondition", val);
  };

  const ApplicationTypeEnum = {
    Fixed: 0,
    Tender: 1,
    Bid: 2,
    Turnover: 3,
  };

  const ApplicationTypeEnumBronze = {
    Fixed: 0,
    Tender: 1,
    Bid: 2,
  };
  const handleApplicationType = (e) => {
    const val = e.target.value;
    setEventApplicationData({ ...eventApplicationData, applicationType: val });
    setValue("applicationType", val);
  };

  const getActivePlanData = async () => {
    props.application.setLoading(true);

    try {
      const res = await SubscriptionService.getActiveSubscriptionById(
        loginUser?.id
      );
      if (res?.isSuccess) {
        if (res?.data?.subscriptionPlanName) {
          setSeletedPlan(
            res?.data?.subscriptionPlanName?.toLowerCase().includes("bronze")
          );
        } else {
          setSeletedPlan(true);
        }
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      setSeletedPlan("noplan");
    }
  };

  const getDocumentData = async () => {
    try {
      const res = await DocumentTypeService.getDocumentTypeList();
      if (res?.isSuccess) {
        if (res?.data) {
          const filterdoc = res?.data
            .filter((x) => x.isActive === true)
            .map((x) => {
              return {
                id: x.id,
                documentName: x.documentName,
                checked: false,
              };
            });
          return filterdoc;
        } else {
          return [];
        }
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    register("id");
    // Call getEventApplication whenever param changes
    param === "C"
      ? setApplicationForHeading("Caterer")
      : setApplicationForHeading("Retail");
    setApplicationForValue(param);
    register("termsCondition");

    //await getDocumentData();
    getEventApplication();
    // Set the heading based on the param

    // For Auto Generate Terms and Conditions
    const EventId = eventId;
    if (param) {
      getContractTermsAndConditions(EventId, param);
    }
    getActivePlanData();
  }, [param]);

  //************ Get Event Contract Data **********
  const getContractTermsAndConditions = async (EventId, param) => {
    props.application.setLoading(true);
    try {
      const res = await EventContractService.getEventContractByEventId(EventId);
      if (res?.isSuccess) {
        if (param === "C") {
          const matchedContract = res?.data.find(
            (item) =>
              item.contractFor === "C" &&
              item.contractName === "Terms & Condition Caterers"
          );
          if (matchedContract) {
            setContractTC(matchedContract.contractDtl);
            setValue("termsCondition", matchedContract?.contractDtl);
          }
        } else {
          const matchedContract = res?.data.find(
            (item) =>
              item.contractFor === "R" &&
              item.contractName === "Terms & Condition Retailers"
          );
          if (matchedContract) {
            setContractTC(matchedContract?.contractDtl);
            setValue("termsCondition", matchedContract?.contractDtl);
          }
        }
      }
    } catch (error) {
      const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    } finally {
      props.application.setLoading(false);
    }
  };

  const validateAuctionDate = (value) => {
    const deadLineDate = getValues("deadLine");
    if (deadLineDate && deadLineDate < value) {
      return "Please enter a valid start date, should be before deadline date.";
    }
    return true;
  };

  const handleCheckboxChange = (e, doc) => {
    setDocumentList((prevCheckboxes) =>
      prevCheckboxes.map((checkbox) =>
        checkbox.id === doc.id
          ? { ...checkbox, checked: !checkbox.checked } // Toggle checked state
          : checkbox
      )
    );

    var documents = seletedDocments;
    if (e.target.checked && !seletedDocments.includes(doc)) {
      documents.push(doc);
    } else {
      documents = documents.filter(
        (x) => `${x.id.toLowerCase()}` !== doc?.id?.toLowerCase()
      );
    }
    setSelectedDocuments(documents);
    const ids =
      documents.length > 0 ? documents.map((item) => item.id).join(", ") : null;
    if (ids && ids.length > 0) {
      setDocError("");
    }
    setValue("requiredDocuments", ids);
  };

  return (
    <React.Fragment>
      <div>
        <section>
          <Modal isOpen={isModalOpen} onClose={closeModal}>
            <ImageUpload
              imageURL={previewImageURL}
              onUpload={handleImageUpload}
              maxSize={4 * 1024 * 1024}
              validTypes={["image/png", "image/gif", "image/jpeg"]}
            ></ImageUpload>
          </Modal>
          <section className="subscription-banner p-0">
            <div className="container">
              <h3>
                Create{" "}
                {applicationForHeading === "Retail"
                  ? "Retail Trade Stand"
                  : applicationForHeading}{" "}
                Application
              </h3>
            </div>
          </section>
          <Form.Group controlId="unitList">
            <Form.Control type="hidden" {...register("requiredDocuments")} />
          </Form.Group>

          <Form className="row" onSubmit={handleSubmit(onSubmit)} noValidate>
            <Form.Group className="mb-3">
              <Form.Label>
                Application Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                maxLength={200}
                type="text"
                {...register("title", { required: "Title is required" })}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue(
                    "title",
                    value?.charAt(0)?.toUpperCase() + value?.slice(1)
                  );
                }}
              />
              {errors?.title && (
                <span className="text-danger">{errors?.title?.message}</span>
              )}
            </Form.Group>
            <Form.Group
              controlId="deadLine"
              className="col-md-6 col-sm-12 mb-3"
            >
              <Form.Label>
                Application Deadline <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                min={minDate || undefined}
                max={maxDate || undefined}
                {...register("deadLine", {
                  required: "Deadline is required",
                  min: {
                    value: minDate,
                    message: `Date must be after ${formatDateENGB(
                      minDate || undefined
                    )}`,
                  },
                  max: {
                    value: maxDate,
                    message: `Date must be before ${formatDateENGB(
                      maxDate || undefined
                    )}`,
                  },
                })}
                placeholder="dd-mm-yyyy" // Placeholder in the desired format
              />
              {errors?.deadLine && (
                <span className="text-danger">{errors?.deadLine?.message}</span>
              )}
            </Form.Group>

            {applicationForValue === "D" && (
              <Form.Group className="col-md-6 col-sm-12 mb-3">
                <Form.Label>
                  Applicable Fee (£) <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  maxLength={10}
                  type="text"
                  {...register("amount", {
                    required: "Amount is required",
                    pattern: {
                      value: /^[+]?[0-9]*\.?[0-9]+$/,
                      message: "Please enter a valid number greater than zero.",
                    },
                  })}
                />
                {errors?.amount && (
                  <span className="text-danger">{errors?.amount?.message}</span>
                )}
              </Form.Group>
            )}

            <Form.Group
              className="col-md-6 col-sm-12 mb-3"
              controlId="initialPaymentPer"
            >
              <Form.Label>Initial Payment Percentage</Form.Label>
              <Form.Control
                type="text"
                {...register("initialPaymentPer", {
                  required: "Please enter a percentage",
                  pattern: {
                    value: /^(\d{1,2}(\.\d{1,2})?|100(\.0{1,2})?)$/,
                    message: "Please enter a valid number between 50 and 100.",
                  },
                })}
                onChange={handlePercentageChange}
              ></Form.Control>
              {errors?.initialPaymentPer && (
                <span className="text-danger">
                  {errors?.initialPaymentPer?.message}
                </span>
              )}
            </Form.Group>
            {selectedPercentage !== "100" && selectedPercentage !== 100 && (
              <Form.Group
                controlId="payOutDate"
                className="col-md-6 col-sm-12 mb-3"
              >
                <Form.Label>
                  Second Payment Interval (in weeks)
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  maxLength={3}
                  type="text"
                  {...register("secondPaymentInterval", {
                    required: "Second Payment Interval is required",
                    pattern: {
                      value: /^(?:[1-9]|[1-8][0-9]|90)$/,
                      message:
                        "Please enter a valid number between 1 to  90, decimal number not allowed.",
                    },
                  })}
                />
                {errors?.secondPaymentInterval && (
                  <span className="text-danger">
                    {errors?.secondPaymentInterval?.message}
                  </span>
                )}
              </Form.Group>
            )}
            <Form.Group className="col-md-6 col-sm-12 mb-6 app-status app-status-active">
              <Form.Check
                type="checkbox"
                label="Set Live"
                {...register("isActive")}
                defaultChecked={false}
              />
            </Form.Group>
            {/* added aution changes  */}
            <Form.Group
              className="col-md-6 col-sm-12 mb-3"
              controlId="applicationType"
            >
              <Form.Label>Application Price Type</Form.Label>
              <Form.Select
                //as="select"
                {...register("applicationType", {
                  required: "Please select a percentage",
                })}
                onChange={handleApplicationType}
              >
                {isBronzePlan &&
                  Object.entries(ApplicationTypeEnumBronze).map(
                    ([key, value]) => (
                      <option key={key} value={value}>
                        {key}
                      </option>
                    )
                  )}
                {!isBronzePlan &&
                  Object.entries(ApplicationTypeEnum).map(([key, value]) => (
                    <option key={key} value={value}>
                      {key}
                    </option>
                  ))}
              </Form.Select>
              {errors?.applicationType && (
                <span className="text-danger">
                  {errors?.applicationType?.message}
                </span>
              )}
            </Form.Group>
            {(Number(eventApplicationData.applicationType) ===
              Number(ApplicationType.Bid) ||
              Number(eventApplicationData.applicationType) ===
                Number(ApplicationType.Tender)) && (
              <React.Fragment>
                <Form.Group
                  className="col-md-6 col-sm-12 mb-3"
                  controlId="auctionsDays"
                >
                  <Form.Label>
                    Duration in Days (from 3 days up to a maximum of 90 days)
                  </Form.Label>
                  <Form.Control
                    maxLength={10}
                    type="text"
                    {...register("auctionsDays", {
                      required: "Auction Days is required",
                      pattern: {
                        value: /^(?:[3-9]|[1-8][0-9]|90)$/,
                        message:
                          "Please enter a valid number between 3 to  90.",
                      },
                    })}
                  />
                  {errors?.auctionsDays && (
                    <span className="text-danger">
                      {errors?.auctionsDays?.message}
                    </span>
                  )}
                </Form.Group>
                <Form.Group
                  className="col-md-6 col-sm-12 mb-3"
                  controlId="auctionStartDate"
                >
                  <Form.Label>
                    {Number(eventApplicationData.applicationType) ===
                    Number(ApplicationType.Tender)
                      ? "Tender Start Date"
                      : "Auction Start Date"}{" "}
                  </Form.Label>
                  <Form.Control
                    type="date"
                    {...register("auctionStartDate", {
                      required: "Auction start date is required",
                      min: {
                        value: minDate || undefined,
                        message: `Date must be after ${formatDateENGB(
                          minDate || undefined
                        )}`,
                      },
                      max: {
                        value: maxDate || undefined,
                        message: `Date must be before ${formatDateENGB(
                          maxDate || undefined
                        )}`,
                      },
                      validate: validateAuctionDate,
                    })}
                    min={minDate || undefined}
                    max={maxDate || undefined}
                  />

                  {errors?.auctionStartDate && (
                    <span className="text-danger">
                      {errors?.auctionStartDate?.message}
                    </span>
                  )}
                </Form.Group>
              </React.Fragment>
            )}

            <Form.Group controlId="smallDecription" className="mb-3 mt-2">
              <Form.Label>
                Required Documents from Traders{" "}
                <span className="text-danger">*</span>
              </Form.Label>
              <div className="form-control">
                {documentList?.map((doc) => (
                  <div key={doc.id} className="mb-3">
                    <Form.Check
                      key={doc.id}
                      type="checkbox"
                      id={`checkbox-${doc.id}`}
                      label={doc.documentName}
                      checked={doc.checked} // Controlled value
                      onChange={(e) => handleCheckboxChange(e, doc)} // Handle change for each checkbox
                    />
                  </div>
                ))}
              </div>
              {docerror && <span className="text-danger">{docerror}</span>}
            </Form.Group>
            <Form.Group controlId="smallDecription" className="mb-3 mt-2">
              <Form.Label>Small Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                {...register("smallDecription")}
                maxLength={500}
              />
              {errors?.smallDecription && (
                <span className="text-danger">
                  {errors?.smallDecription?.message}
                </span>
              )}
            </Form.Group>
            <Form.Group controlId="description" className="mb-3">
              <Form.Label>Long Description</Form.Label>
              <Editor
                style={{ height: "200px" }}
                value={eventApplicationData?.description}
                onChange={handleDescription}
                // toolbar={false}
              />
              {errors?.description && (
                <span className="text-danger">
                  {errors?.description?.message}
                </span>
              )}
            </Form.Group>

            <Form.Group controlId="termsCondition" className="mb-3">
              <Form.Label>Terms & Condition</Form.Label>
              <Editor
                style={{ height: "200px" }}
                // value={eventApplicationData.termsCondition}
                value={contractTC}
                onChange={handleTermsCondition}
              />
            </Form.Group>

            <div>
              <div className="up-img69 mb-3">
                <ImagePreview
                  src={previewImageURL}
                  width=""
                  height="auto"
                  style={{
                    marginBottom: "15px",
                  }}
                />
                <div className="upload-edit">
                  <h6>
                    <span onClick={openCoverModal}>
                      <a href="#!">
                        <i className="fa fa-solid fa-arrow-up"> Upload Image</i>
                      </a>
                    </span>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12 row">
              <div className="col-6">
                <div className="back-bt12 back1">
                  <span
                    onClick={(e) => handleBackButton(e)}
                    className="btn btn-primary"
                  >
                    Back
                  </span>
                </div>
              </div>
              <div className="col-6">
                <div className="back-bt12 save2">
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </section>
      </div>
    </React.Fragment>
  );
};

export default injectModels(["application"])(AddEventApplication);
